/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull request-manager'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 84
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest)
 *
 * [Full Setup Instructions](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/implementation/request-manager)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: 'cd66d5f09757f2105f0421f19902fd36',
  development: '02bc6b26d05869deb28d323baca5528b'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '84',
    branch: 'main',
    source: 'request-manager',
    versionId: 'e782db38-0a57-44e1-aa52-798241b2febc'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  },
  serverZone: amplitude.Types.ServerZone.EU
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  agency_id?: number;
  agency_name?: string;
  device_category?: string;
  /**
   * User ID, it correponds to the ID of the agent
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  user_id?: number;
  utm_source?: string;
}

export interface AbsenceStatusSubmittedProperties {
  absence_status_checked: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface AgentAttributionManagedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface AgentTestimonialClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  has_agent_testimonial: boolean;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface AnswerMessageLatencyClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface At1PropositonDisplayedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface At1ScheduledProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface At1CustomizeLinkClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
}

export interface At2MessageActionClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | my_version, optimized_version |
   */
  at2_action_type: "my_version" | "optimized_version";
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  message_id?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface At2MessageCheckResultProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  at2_need_correction: boolean;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  message_id?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface At2MessageCheckStartedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  message_id?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface At2MessageEditSuggestionDisplayedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  message_id?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface AttachedDocumentExplanationToggledProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface AttachedDocumentSendClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  number_of_before_trip_documents: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  number_of_in_trip_documents: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  number_of_quotes: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  number_of_roadbooks: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface BudgetNotificationClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface BudgetUpdatedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  budget_value?: number;
  destination_slug: string;
  is_agent_assigned: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  last_budget_before_update?: number;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface CardDraggedOrDroppedProperties {
  /**
   * Correspond to the column where the user drags the card
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | discovery, postponed, new_request, quote_creation, construction, quote_validated, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  drag_column:
    | "discovery"
    | "postponed"
    | "new_request"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  /**
   * Correspond to the column where the user drops the card
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | discovery, postponed, new_request, quote_creation, construction, quote_validated, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  drop_column:
    | "discovery"
    | "postponed"
    | "new_request"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
}

export interface CollectCapacityReminderChoiceClickedProperties {
  /**
   * Le choix fait par l'agent sur le reminder de la saisie de la capacité de son agence
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | remind_me_later, not_concerned, confirm_capacity |
   */
  collect_capacity_reminder_choice: "remind_me_later" | "not_concerned" | "confirm_capacity";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface DetailsInitialRequestClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface DiscussionAddADocumentClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface DiscussionAddATemplateClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface DiscussionTemplateSelectedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface DisplayViewedLatencyPopInProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface DocumentationLatencyClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface DueDateSubmittedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface ExperimentAt1MessageErasedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface FaqClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | ets menu, navbar, cta |
   */
  click_origin?: "ets menu" | "navbar" | "cta";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface FilterSelectedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  filtered_by_agent: boolean;
  filtered_by_budget: boolean;
  filtered_by_destination: boolean;
  filtered_by_group_6_pax: boolean;
  filtered_by_rating: boolean;
  filtered_by_request_date: boolean;
  filtered_by_solo_traveler: boolean;
  filtered_by_start_date_of_services: boolean;
  filtered_by_to_reply: boolean;
  filtered_by_type_of_actions: boolean;
}

export interface GenerateAt1DisplayedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface GenerateAt1MessageClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface GenerateRecapCallRmClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface GiveFeedbackClickedProperties {
  /**
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Yes, No, accepted, ignored, keep_both |
   */
  answer: "Yes" | "No" | "accepted" | "ignored" | "keep_both";
  content_feedback?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * afin de détecter il s'agit de d'un feature lié a AT1 auto dans la discussion![](https://com-amplitude-orbit-media-prod-eu.s3.eu-central-1.amazonaws.com/100000330/52b79de6-c9d3-40db-914a-0516475af91b.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAS6JMKSBOVG3BQFIL%2F20260212%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20260212T154458Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEA0aDGV1LWNlbnRyYWwtMSJGMEQCIE8Gl4wSbRlqiCFhMNAgXvsXAQydBS6hkwzdqFS92zQyAiATSMRauUhKwL67wAolP%2BaQlzyoKtK6Tak3RWzK7lpLLirOBQjW%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDIwMjQ5MzMwMDgyOSIMnkzOOIlePgHDMGUgKqIFh9%2B1n1RAu1GOvBP6c0xge88zOmoULXMhghJN4hhSc0CKQVqNa9yZ1Jk%2Fe%2Bjg%2BlG0k2R3c6stej2KW%2B%2Ber56bcrDjnY2ZDA29P%2BEDLyyQKemK3hSvL93vkh2mGq1jNotNEVceMyxd7WegRK7zX93oXN2OkOdYh%2FM2NqoJj4FLNM20HYN1YtIfZAxFDqUCzj2vo%2BDvMdxu9eSz7RNZlQitoR4787nRN31sIhlzYWhyEqwPt2Hf6uWuHo6DDmAdnekx2DfkRLMW%2BnyOu3X8f3isDE8PqqQya60KraSv40NWUrIxvtDD4cDQ0Fy2cf3Xdb81H%2F6JYPTIDJecIkHYZpxEv%2Bp0XunyUXwVugx6iCazg%2FKx0XklMbeiboC%2Fhbs9l7lFmJ8HuyAQ5kQresFD6F7bImbr1vCDujdiWJ1IWA%2FxcGGna8%2BAPcxyvBSjHIVL6iyScrR87%2FLbHA%2FnEx64VcfX4XlNOiNjQVNm74psFVwF9ebemHhNAmorm8F3x900WMmHDnkMQky0VlNCPty8vjwEifcWWV%2BOphukcLJWLgElJqoQp%2FMT9%2FKhM4iDqODPKQQBg8ZjuT4hAOMwYIMmkegoN949tN5qZK4mvH6zRrsOPLXkP8uayHAdzhsnrSchfCiWhgqK9%2BHvZdv7DrSDf%2FaZaNLDte70g1%2Fc%2F3XMABIYZBDSdIFC5HrqO%2Bg1nfcokUrIvXwOXq%2FwNBDPOJcEUs1F4fvxZCM5basy%2BYrt2p5eGrF9%2BFi8L4qDwtzdsP%2FEO82a6le36emAuaYRDQjO3dYmaIW5rE7sjETs2h7ir77s4ebgEZsfNM6JfkHBsOa2XgE943QrYSLbTFMw8Bo76Je%2B6DkuYn18j6s2bHLJqTluKLIBP5T9gIv%2BNFBiRkcXcFLxIRAw2Z23zAY6sgETqTJS7BbE40wgy%2FRwuMQ06reUP7BFyv%2B6UhA2DvhPXL%2FzFKOQzK9PF0SZCoRbSl8adcwsUWjNUEaNPejQSz9FAom12EvVCTIawtSTdcktrDIvgtj6BFTntEcigsCIBtoa7Zpw2SJt8vTZQQ91D0JhVuydBJ0EaCE%2FWv8lWp8Tku8Tl9LqBYVpnYOua%2BfovdSVPk8TmAiA67ZNr5K5MXxqqGFlCoWME24GLEj3rVpmIQd5&X-Amz-Signature=5cb737602556f2b5cb2ec5f92f9b24757be1c52e07b70ac18d55c05d3049de9f&X-Amz-SignedHeaders=host&x-id=GetObject)
   */
  is_at1_auto: boolean;
}

export interface HideFeedbackClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * Feedback is positive or negative
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | (Positive|Negative) |
   */
  feedback_answers?: string;
  /**
   * File has in trip ou pre booking feedback.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | (In trip|Pre booking) |
   */
  feedback_type?: string;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface HomepageViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | default_redirect, inbox_button |
   */
  entry_point: "default_redirect" | "inbox_button";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  nb_messages: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  nb_new_files: number;
  /**
   *
   *
   *  compte le nombre de notifications importantes sur la nouvelle homepage RM
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  nb_notification: number;
  nb_overdue_messages: string;
  nb_overdue_new_files: string;
}

export interface ItineraryClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface ListAttachmentsClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface MainInformationChangedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * Donne l'info de quel champ de la vue dossier précisément a été modifié.
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | name, phone number, nb pax, trip dates |
   */
  edited_field: "name" | "phone number" | "nb pax" | "trip dates";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface MarkTheFileAsLostSubmittedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  maturity_latence?: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface MeetingRoomCopiedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface MeltingspotLightbulbClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface MemoClosedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface MemoExpandedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface MemoSavedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface MessageEditCancelClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface MessageEditClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface MessageEditSubmitClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface NbaNoteSubmittedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * Name of the nba
   */
  nba_name: string;
  /**
   * Step of the NBA
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  nba_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface NewTagAddedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  /**
   * tag content (text)
   */
  tag_file_content: string;
}

export interface NewTemplateSubmittedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface NewFileClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * Est-ce que le message est sans réponse depuis plus de xh ?
   */
  is_overdue: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home, pipeline |
   */
  source: "home" | "pipeline";
}

export interface NewMessageClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * Est-ce que le message est sans réponse depuis plus de xh ?
   */
  is_overdue: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  message_id?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
}

export interface NewNotificationClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  notification_read: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | instalment_paid, proposal_validated, accommodations_selected, automatically_set_lost, at1_auto |
   */
  notification_type:
    | "instalment_paid"
    | "proposal_validated"
    | "accommodations_selected"
    | "automatically_set_lost"
    | "at1_auto";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
}

export interface NextBestActionSubmittedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * Est-ce qu'un commentaire a été saisi dans l'espace de planification de la nba?
   */
  has_comment: boolean;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * Name of the nba
   */
  nba_name: string;
  /**
   * Step of the NBA
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  nba_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  next_best_action_suggested_clicked: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface OptionWayClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface OverdueMessageClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  message_id?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
}

export interface PanelContractViewedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface PhoneNumberViewedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface PostponeRequestClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface QuickActionUsedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | mark_no_response_needed, answered_outside_RM, notification_read, notification_unread |
   */
  action_type: "mark_no_response_needed" | "answered_outside_RM" | "notification_read" | "notification_unread";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  message_id?: number;
}

export interface RawTranscriptOpenedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * identifiant unique du call
   */
  call_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RecordingDownloadedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * identifiant unique du call
   */
  call_id: string;
  destination_slug: string;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RecordingListenedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * identifiant unique du call
   */
  call_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RecordingPausedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * identifiant unique du call
   */
  call_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RecordingStartedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * identifiant unique du call
   */
  call_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   *
   *
   *
   * On veut distinguer dans le tracking quand un user appuie sur :
   *
   * * 'Enregistrer' dans le **Widget**
   *
   * * 'Enregistrer' dans la **nouvelle Modale d'incitation à l'enregistrement** (cf. screen)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | widget, modale |
   */
  recording_source: "widget" | "modale";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RegenerateRecordingAiContentClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  /**
   * Describes the generated content of a call recording.
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | recording summary, recording raw transcript |
   */
  source_regeneration: "recording summary" | "recording raw transcript";
}

export interface ReopenFileProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RevealMessageLatencyClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RmAssistantOfferACallSubmittedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RmAssistantAccessToFilesClickedProperties {
  /**
   * Cette propriété a pour but d'identifier le bloc dans lequel l'event a été déclenché
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | follow up, call, quote, response |
   */
  block_assistant_task: "follow up" | "call" | "quote" | "response";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface RmAssistantArrowClickedProperties {
  /**
   * If the user clic on the right arrow is NEXT
   *  If the user clic on the left arrow is PREVIOUS
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Next, Previous |
   */
  assistant_arrow_direction: "Next" | "Previous";
  /**
   * Cette propriété a pour but d'identifier le bloc dans lequel l'event a été déclenché
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | follow up, call, quote, response |
   */
  block_assistant_task: "follow up" | "call" | "quote" | "response";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface RmAssistantCallDoneSubmittedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RmAssistantClickedProperties {
  /**
   * number of files total displayed by the assistant rm
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 30 |
   */
  assistant_number_files: number;
  /**
   * number of files displayed by the assistant rm to answer
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 15 |
   */
  assistant_number_files_to_answer: number;
  /**
   * number of files displayed by the assistant rm to call
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 15 |
   */
  assistant_number_files_to_call: number;
  /**
   * number of files displayed by the assistant rm to follow up
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 15 |
   */
  assistant_number_files_to_follow_up: number;
  /**
   * number of files displayed by the assistant rm waiting for quote
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 15 |
   */
  assistant_number_files_waiting_for_quote: number;
  /**
   * Cette propriété a pour but d'identifier le bloc dans lequel l'event a été déclenché
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | inbox, pipeline, to do |
   */
  block_request_manager: "inbox" | "pipeline" | "to do";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface RmAssistantClosedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface RmAssistantFileDisplayedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * Cette propriété a pour but d'identifier le bloc dans lequel l'event a été déclenché
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | follow up, call, quote, response |
   */
  block_assistant_task: "follow up" | "call" | "quote" | "response";
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RmAssistantMessageSentProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * Cette propriété a pour but d'identifier le bloc dans lequel l'event a été déclenché
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | follow up, call, quote, response |
   */
  block_assistant_task: "follow up" | "call" | "quote" | "response";
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * If the message is with the template submitted by rm_assistant is true
   */
  is_rm_assistant_template: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RmAssistantModalDisplayedProperties {
  /**
   * number of files total displayed by the assistant rm
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 30 |
   */
  assistant_number_files: number;
  /**
   * number of files displayed by the assistant rm to answer
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 15 |
   */
  assistant_number_files_to_answer: number;
  /**
   * number of files displayed by the assistant rm to call
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 15 |
   */
  assistant_number_files_to_call: number;
  /**
   * number of files displayed by the assistant rm to follow up
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 15 |
   */
  assistant_number_files_to_follow_up: number;
  /**
   * number of files displayed by the assistant rm waiting for quote
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 15 |
   */
  assistant_number_files_waiting_for_quote: number;
  /**
   * Cette propriété a pour but d'identifier le bloc dans lequel l'event a été déclenché
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | inbox, pipeline, to do |
   */
  block_request_manager: "inbox" | "pipeline" | "to do";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface RmAssistantNextFileClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * Cette propriété a pour but d'identifier le bloc dans lequel l'event a été déclenché
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | follow up, call, quote, response |
   */
  block_assistant_task: "follow up" | "call" | "quote" | "response";
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RmAssistantProposalSentSubmittedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RmAssistantTaskNotNecessaryClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * Cette propriété a pour but d'identifier le bloc dans lequel l'event a été déclenché
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | follow up, call, quote, response |
   */
  block_assistant_task: "follow up" | "call" | "quote" | "response";
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RmDiscussionResponseNoRequiredSubmittedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface RmFilterClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | todo, pipeline, inbox |
   */
  category: "todo" | "pipeline" | "inbox";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface SalePotentialSelectedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * Previous level of sale potential on the file before sale potential qualification selected
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | none, hot, warm, cold |
   */
  heat_level_before_sale_potential_selected: "none" | "hot" | "warm" | "cold";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | none, hot, warm, cold |
   */
  sale_potential_level: "none" | "hot" | "warm" | "cold";
}

export interface SaleStepChangedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface SaveAgentTestimonialClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface ScheduledMessageCancelledProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface ScheduledMessageConfirmedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  delay_day: number;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  has_attachment: boolean;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  scheduled_datetime: string;
}

export interface ScheduledMessageDeletedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  scheduled_datetime: string;
}

export interface ScheduledMessageEditedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  scheduled_datetime: string;
}

export interface ScheduledMessageOpenModalProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface SeeReviewClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface SendMessageClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * permet de déterminer si le message envoyé est l'AT1 ou non.
   */
  is_at1: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * `manual` - message écrit manuellement par l'agent
   *
   * `call_recap` - récapitulatif généré depuis la synthèse d'appel RM
   *
   * `at1_suggestion` - at1 suggestion developpé par FAME
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | manual, call_recap, at1_suggestion |
   */
  message_source: "manual" | "call_recap" | "at1_suggestion";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  /**
   * Similiraity Score in % between 2 texts
   *
   * Si le score de similarité n'est pas disponible (exemple sur l'event `Send message clicked`) alors on envoie une valeur par défaut : -1
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  similarity_score: number;
}

export interface SendWithAt1FamilyPropositionProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  /**
   * Similiraity Score in % between 2 texts
   *
   * Si le score de similarité n'est pas disponible (exemple sur l'event `Send message clicked`) alors on envoie une valeur par défaut : -1
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  similarity_score: number;
}

export interface SummaryAiTranscriptViewedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * identifiant unique du call
   */
  call_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface SummarySegmentClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * identifiant unique du call
   */
  call_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface TagDeletedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  /**
   * tag content (text)
   */
  tag_file_content: string;
}

export interface TagSelectedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  /**
   * tag content (text)
   */
  tag_file_content: string;
}

export interface TestAt1PropositonDisplayedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface ToDoSubTabClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | today, tomorrow, this_week |
   */
  to_do_sub_tab_name: "today" | "tomorrow" | "this_week";
}

export interface TranscriptViewedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  /**
   * identifiant unique du call
   */
  call_id: string;
  /**
   *
   *  The origin of the click that triggered the transcript view. Indicates whether the agent accessed the transcript from the notification toast (when synthesis is ready) or from the conversation interface.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | toast, discussion |
   */
  click_source: "toast" | "discussion";
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  /**
   * Indique si la synthèse existe ou non
   */
  synthesis_content: string;
}

export interface TravelerCallClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface TravelerCallEndedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface TravelerCallMinimizedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface TravelerCallNoteClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface TravelerCallStartedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface TravelerInformationChangedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * Donne l'info de quel champ de la vue dossier précisément a été modifié.
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | name, phone number, nb pax, trip dates |
   */
  edited_field: "name" | "phone number" | "nb pax" | "trip dates";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface TravelerInfoLinkClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
}

export interface VideoLinkGeneratedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface ViewFeedbackClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * File has in trip ou pre booking feedback.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | (In trip|Pre booking) |
   */
  feedback_type?: string;
}

export interface ViewedLatencyTestReplyClickedProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export interface ViewedPageFileProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * Feedback is positive or negative
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | (Positive|Negative) |
   */
  feedback_answers?: string;
  /**
   * File has in trip ou pre booking feedback.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | (In trip|Pre booking) |
   */
  feedback_type?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | information, discussion, contract, main_information, steps, price, fixed_departure, seasonality, range, my_trip, day_by_day, step_by_step, pricing, homepage, main_contacts, fr_market, es_market, it_market, dach_market, nl_market, market, destination, choose_type |
   */
  file_tab:
    | "information"
    | "discussion"
    | "contract"
    | "main_information"
    | "steps"
    | "price"
    | "fixed_departure"
    | "seasonality"
    | "range"
    | "my_trip"
    | "day_by_day"
    | "step_by_step"
    | "pricing"
    | "homepage"
    | "main_contacts"
    | "fr_market"
    | "es_market"
    | "it_market"
    | "dach_market"
    | "nl_market"
    | "market"
    | "destination"
    | "choose_type";
  has_budget_filled: boolean;
  has_tripform_budget_filled: boolean;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * nb of tags which have been selected on the file
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   * | Max Value | 3 |
   */
  nb_tag_file: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * Nombre d'étoiles attrirbué à la request avec le système de qualif V2 (partie control du test maturity sur la critère mobile dans la qualif des requests).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 1, 2, 3, 4, 5 |
   */
  request_rating_with_mobile_criteria?: "1" | "2" | "3" | "4" | "5";
  /**
   * Nombre d'étoiles affiché avec un système de qualification qui ne prends pas en compte le mobile (partie variation du test de maturity sur le critère mobile au sein de la qualification)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | 1, 2, 3, 4, 5 |
   */
  request_rating_without_mobile_criteria?: "1" | "2" | "3" | "4" | "5";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | none, hot, warm, cold |
   */
  sale_potential_level: "none" | "hot" | "warm" | "cold";
}

export interface ViewedPageInboxProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface ViewedPagePipelineProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  /**
   * Identificate on which tab is the user: sales | operation | archive
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | sales, operation, archive |
   */
  pipeline_tab: "sales" | "operation" | "archive";
}

export interface ViewedPageTemplateProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface ViewedPageTodoProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
  has_intrip_feedback?: boolean;
  /**
   * To Do page has pre booking feedback.
   */
  has_prebooking_feedback?: boolean;
  /**
   * Identificate on which tab is the user: today | tomorrow | this_week
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | today, tomorrow, this_week |
   */
  todo_tab: "today" | "tomorrow" | "this_week";
}

export interface WorkloadStatusClickedProperties {
  /**
   * Match workload levels within the modal UI
   *
   *
   *
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | underloaded, overloaded, good |
   */
  agent_workload_level: "underloaded" | "overloaded" | "good";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface AttachedDocumentsTypeProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  number_of_before_trip_documents: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  number_of_in_trip_documents: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  number_of_quotes: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  number_of_roadbooks: number;
}

export interface DefaultPropertyGroupProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | agency_insights, request_manager, trip_planner, agency_manager, offer_manager, cash_manager |
   */
  ets_source:
    | "agency_insights"
    | "request_manager"
    | "trip_planner"
    | "agency_manager"
    | "offer_manager"
    | "cash_manager";
}

export interface FileFeedbackProperties {
  /**
   * Feedback is positive or negative
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | (Positive|Negative) |
   */
  feedback_answers?: string;
  /**
   * File has in trip ou pre booking feedback.
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | (In trip|Pre booking) |
   */
  feedback_type?: string;
}

export interface NbaProperties {
  /**
   * Est-ce qu'un commentaire a été saisi dans l'espace de planification de la nba?
   */
  has_comment: boolean;
  /**
   * Name of the nba
   */
  nba_name: string;
  /**
   * Step of the NBA
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  nba_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  next_best_action_suggested_clicked: boolean;
}

export interface RequestManagerFiltersProperties {
  filtered_by_agent: boolean;
  filtered_by_budget: boolean;
  filtered_by_destination: boolean;
  filtered_by_group_6_pax: boolean;
  filtered_by_rating: boolean;
  filtered_by_request_date: boolean;
  filtered_by_solo_traveler: boolean;
  filtered_by_start_date_of_services: boolean;
  filtered_by_to_reply: boolean;
  filtered_by_type_of_actions: boolean;
}

export interface TripProperties {
  /**
   * agency_id for evaneos
   */
  agency_id: string;
  destination_slug: string;
  is_agent_assigned: boolean;
  /**
   * Specifies the name of the market relevant to the event on the webpage. This property helps in identifying and categorizing the market associated with the data.
   */
  market_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  request_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 1 |
   * | Max Value | 5 |
   */
  request_rating: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | new_request, discovery, quote_creation, construction, quote_validated, postponed, payment_confirmed, trip_preparation, travelling, deferred_trip, trip_has_ended, closed, cancelled, lost |
   */
  request_RM_step:
    | "new_request"
    | "discovery"
    | "quote_creation"
    | "construction"
    | "quote_validated"
    | "postponed"
    | "payment_confirmed"
    | "trip_preparation"
    | "travelling"
    | "deferred_trip"
    | "trip_has_ended"
    | "closed"
    | "cancelled"
    | "lost";
  request_status: string;
  requester_id: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AbsenceStatusSubmitted implements BaseEvent {
  event_type = 'Absence status submitted';

  constructor(
    public event_properties: AbsenceStatusSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AgentAttributionManaged implements BaseEvent {
  event_type = 'Agent attribution managed';

  constructor(
    public event_properties: AgentAttributionManagedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AgentTestimonialClicked implements BaseEvent {
  event_type = 'Agent testimonial clicked';

  constructor(
    public event_properties: AgentTestimonialClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AnswerMessageLatencyClicked implements BaseEvent {
  event_type = 'Answer message latency clicked';

  constructor(
    public event_properties: AnswerMessageLatencyClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class At1PropositonDisplayed implements BaseEvent {
  event_type = 'At1 propositon displayed';

  constructor(
    public event_properties: At1PropositonDisplayedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class At1Scheduled implements BaseEvent {
  event_type = 'AT1 scheduled';

  constructor(
    public event_properties: At1ScheduledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class At1CustomizeLinkClicked implements BaseEvent {
  event_type = 'AT1_customize_link_clicked';

  constructor(
    public event_properties: At1CustomizeLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class At2MessageActionClicked implements BaseEvent {
  event_type = 'AT2 message action clicked';

  constructor(
    public event_properties: At2MessageActionClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class At2MessageCheckResult implements BaseEvent {
  event_type = 'AT2 message check result';

  constructor(
    public event_properties: At2MessageCheckResultProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class At2MessageCheckStarted implements BaseEvent {
  event_type = 'AT2 message check started';

  constructor(
    public event_properties: At2MessageCheckStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class At2MessageEditSuggestionDisplayed implements BaseEvent {
  event_type = 'AT2 message edit suggestion displayed';

  constructor(
    public event_properties: At2MessageEditSuggestionDisplayedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AttachedDocumentExplanationToggled implements BaseEvent {
  event_type = 'Attached document explanation toggled';

  constructor(
    public event_properties: AttachedDocumentExplanationToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AttachedDocumentSendClicked implements BaseEvent {
  event_type = 'Attached document send clicked';

  constructor(
    public event_properties: AttachedDocumentSendClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BudgetNotificationClicked implements BaseEvent {
  event_type = 'Budget notification clicked';

  constructor(
    public event_properties: BudgetNotificationClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BudgetUpdated implements BaseEvent {
  event_type = 'Budget updated';

  constructor(
    public event_properties: BudgetUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CardDraggedOrDropped implements BaseEvent {
  event_type = 'Card dragged or dropped';

  constructor(
    public event_properties: CardDraggedOrDroppedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CollectCapacityReminderChoiceClicked implements BaseEvent {
  event_type = 'Collect capacity reminder choice clicked';

  constructor(
    public event_properties: CollectCapacityReminderChoiceClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DetailsInitialRequestClicked implements BaseEvent {
  event_type = 'Details initial request clicked';

  constructor(
    public event_properties: DetailsInitialRequestClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscussionAddADocumentClicked implements BaseEvent {
  event_type = 'Discussion add a document clicked';

  constructor(
    public event_properties: DiscussionAddADocumentClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscussionAddATemplateClicked implements BaseEvent {
  event_type = 'Discussion add a template clicked';

  constructor(
    public event_properties: DiscussionAddATemplateClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DiscussionTemplateSelected implements BaseEvent {
  event_type = 'Discussion template selected';

  constructor(
    public event_properties: DiscussionTemplateSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DisplayViewedLatencyPopIn implements BaseEvent {
  event_type = 'Display viewed latency pop-in';

  constructor(
    public event_properties: DisplayViewedLatencyPopInProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentationLatencyClicked implements BaseEvent {
  event_type = 'Documentation latency clicked';

  constructor(
    public event_properties: DocumentationLatencyClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DueDateSubmitted implements BaseEvent {
  event_type = 'Due date submitted';

  constructor(
    public event_properties: DueDateSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ExperimentAt1MessageErased implements BaseEvent {
  event_type = 'experiment at1 message erased';

  constructor(
    public event_properties: ExperimentAt1MessageErasedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FaqClicked implements BaseEvent {
  event_type = 'FAQ clicked';

  constructor(
    public event_properties: FaqClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FilterSelected implements BaseEvent {
  event_type = 'Filter_selected';

  constructor(
    public event_properties: FilterSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GenerateAt1Displayed implements BaseEvent {
  event_type = 'Generate AT1 displayed';

  constructor(
    public event_properties: GenerateAt1DisplayedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GenerateAt1MessageClicked implements BaseEvent {
  event_type = 'Generate AT1 message clicked';

  constructor(
    public event_properties: GenerateAt1MessageClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GenerateRecapCallRmClicked implements BaseEvent {
  event_type = 'Generate recap call RM clicked';

  constructor(
    public event_properties: GenerateRecapCallRmClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class GiveFeedbackClicked implements BaseEvent {
  event_type = 'Give feedback clicked';

  constructor(
    public event_properties: GiveFeedbackClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HideFeedbackClicked implements BaseEvent {
  event_type = 'Hide feedback clicked';

  constructor(
    public event_properties: HideFeedbackClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HomepageViewed implements BaseEvent {
  event_type = 'homepage_viewed';

  constructor(
    public event_properties: HomepageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ItineraryClicked implements BaseEvent {
  event_type = 'Itinerary clicked';

  constructor(
    public event_properties: ItineraryClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ListAttachmentsClicked implements BaseEvent {
  event_type = 'List attachments clicked';

  constructor(
    public event_properties: ListAttachmentsClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MainInformationChanged implements BaseEvent {
  event_type = 'Main information changed';

  constructor(
    public event_properties: MainInformationChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MarkTheFileAsLostSubmitted implements BaseEvent {
  event_type = 'Mark the file as lost submitted';

  constructor(
    public event_properties: MarkTheFileAsLostSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MeetingRoomCopied implements BaseEvent {
  event_type = 'Meeting room copied';

  constructor(
    public event_properties: MeetingRoomCopiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MeltingspotLightbulbClicked implements BaseEvent {
  event_type = 'Meltingspot lightbulb clicked';

  constructor(
    public event_properties: MeltingspotLightbulbClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MemoClosed implements BaseEvent {
  event_type = 'Memo closed';

  constructor(
    public event_properties: MemoClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MemoExpanded implements BaseEvent {
  event_type = 'Memo expanded';

  constructor(
    public event_properties: MemoExpandedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MemoSaved implements BaseEvent {
  event_type = 'Memo saved';

  constructor(
    public event_properties: MemoSavedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MessageEditCancelClicked implements BaseEvent {
  event_type = 'message_edit_cancel_clicked';

  constructor(
    public event_properties: MessageEditCancelClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MessageEditClicked implements BaseEvent {
  event_type = 'message_edit_clicked';

  constructor(
    public event_properties: MessageEditClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MessageEditSubmitClicked implements BaseEvent {
  event_type = 'message_edit_submit_clicked';

  constructor(
    public event_properties: MessageEditSubmitClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NbaNoteSubmitted implements BaseEvent {
  event_type = 'NBA note submitted';

  constructor(
    public event_properties: NbaNoteSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewTagAdded implements BaseEvent {
  event_type = 'New tag added';

  constructor(
    public event_properties: NewTagAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewTemplateSubmitted implements BaseEvent {
  event_type = 'New template submitted';

  constructor(
    public event_properties: NewTemplateSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewFileClicked implements BaseEvent {
  event_type = 'new_file_clicked';

  constructor(
    public event_properties: NewFileClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewMessageClicked implements BaseEvent {
  event_type = 'new_message_clicked';

  constructor(
    public event_properties: NewMessageClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NewNotificationClicked implements BaseEvent {
  event_type = 'new_notification_clicked';

  constructor(
    public event_properties: NewNotificationClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NextBestActionSubmitted implements BaseEvent {
  event_type = 'Next best action submitted';

  constructor(
    public event_properties: NextBestActionSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OptionWayClicked implements BaseEvent {
  event_type = 'Option way clicked';

  constructor(
    public event_properties: OptionWayClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OverdueMessageClicked implements BaseEvent {
  event_type = 'overdue_message_clicked';

  constructor(
    public event_properties: OverdueMessageClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PanelContractViewed implements BaseEvent {
  event_type = 'Panel contract viewed';

  constructor(
    public event_properties: PanelContractViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PhoneNumberViewed implements BaseEvent {
  event_type = 'PhoneNumber_Viewed';

  constructor(
    public event_properties: PhoneNumberViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PostponeRequestClicked implements BaseEvent {
  event_type = 'Postpone request clicked';

  constructor(
    public event_properties: PostponeRequestClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class QuickActionUsed implements BaseEvent {
  event_type = 'quick_action_used';

  constructor(
    public event_properties: QuickActionUsedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RawTranscriptOpened implements BaseEvent {
  event_type = 'raw_transcript_opened';

  constructor(
    public event_properties: RawTranscriptOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RecordingDownloaded implements BaseEvent {
  event_type = 'recording_downloaded';

  constructor(
    public event_properties: RecordingDownloadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RecordingListened implements BaseEvent {
  event_type = 'recording_listened';

  constructor(
    public event_properties: RecordingListenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RecordingPaused implements BaseEvent {
  event_type = 'recording_paused';

  constructor(
    public event_properties: RecordingPausedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RecordingStarted implements BaseEvent {
  event_type = 'recording_started';

  constructor(
    public event_properties: RecordingStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RegenerateRecordingAiContentClicked implements BaseEvent {
  event_type = 'Regenerate recording AI content clicked';

  constructor(
    public event_properties: RegenerateRecordingAiContentClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReopenFile implements BaseEvent {
  event_type = 'Reopen file';

  constructor(
    public event_properties: ReopenFileProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RevealMessageLatencyClicked implements BaseEvent {
  event_type = 'Reveal message latency clicked';

  constructor(
    public event_properties: RevealMessageLatencyClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantOfferACallSubmitted implements BaseEvent {
  event_type = 'RM assistant  offer a call submitted';

  constructor(
    public event_properties: RmAssistantOfferACallSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantAccessToFilesClicked implements BaseEvent {
  event_type = 'RM assistant access to files clicked';

  constructor(
    public event_properties: RmAssistantAccessToFilesClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantArrowClicked implements BaseEvent {
  event_type = 'RM assistant arrow clicked';

  constructor(
    public event_properties: RmAssistantArrowClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantCallDoneSubmitted implements BaseEvent {
  event_type = 'RM assistant call done submitted';

  constructor(
    public event_properties: RmAssistantCallDoneSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantClicked implements BaseEvent {
  event_type = 'RM assistant clicked';

  constructor(
    public event_properties: RmAssistantClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantClosed implements BaseEvent {
  event_type = 'RM assistant closed';

  constructor(
    public event_properties: RmAssistantClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantFileDisplayed implements BaseEvent {
  event_type = 'RM assistant file displayed';

  constructor(
    public event_properties: RmAssistantFileDisplayedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantMessageSent implements BaseEvent {
  event_type = 'RM assistant message sent';

  constructor(
    public event_properties: RmAssistantMessageSentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantModalDisplayed implements BaseEvent {
  event_type = 'RM assistant modal displayed';

  constructor(
    public event_properties: RmAssistantModalDisplayedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantNextFileClicked implements BaseEvent {
  event_type = 'RM assistant next file clicked';

  constructor(
    public event_properties: RmAssistantNextFileClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantProposalSentSubmitted implements BaseEvent {
  event_type = 'RM assistant proposal sent submitted';

  constructor(
    public event_properties: RmAssistantProposalSentSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmAssistantTaskNotNecessaryClicked implements BaseEvent {
  event_type = 'RM assistant task not necessary clicked';

  constructor(
    public event_properties: RmAssistantTaskNotNecessaryClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmDiscussionResponseNoRequiredSubmitted implements BaseEvent {
  event_type = 'RM discussion response no required submitted';

  constructor(
    public event_properties: RmDiscussionResponseNoRequiredSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RmFilterClicked implements BaseEvent {
  event_type = 'RM Filter clicked';

  constructor(
    public event_properties: RmFilterClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SalePotentialSelected implements BaseEvent {
  event_type = 'Sale potential selected';

  constructor(
    public event_properties: SalePotentialSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SaleStepChanged implements BaseEvent {
  event_type = 'Sale step changed';

  constructor(
    public event_properties: SaleStepChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SaveAgentTestimonialClicked implements BaseEvent {
  event_type = 'Save agent testimonial clicked';

  constructor(
    public event_properties: SaveAgentTestimonialClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ScheduledMessageCancelled implements BaseEvent {
  event_type = 'ScheduledMessage_Cancelled';

  constructor(
    public event_properties: ScheduledMessageCancelledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ScheduledMessageConfirmed implements BaseEvent {
  event_type = 'ScheduledMessage_Confirmed';

  constructor(
    public event_properties: ScheduledMessageConfirmedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ScheduledMessageDeleted implements BaseEvent {
  event_type = 'ScheduledMessage_Deleted';

  constructor(
    public event_properties: ScheduledMessageDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ScheduledMessageEdited implements BaseEvent {
  event_type = 'ScheduledMessage_Edited';

  constructor(
    public event_properties: ScheduledMessageEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ScheduledMessageOpenModal implements BaseEvent {
  event_type = 'ScheduledMessage_OpenModal';

  constructor(
    public event_properties: ScheduledMessageOpenModalProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SeeReviewClicked implements BaseEvent {
  event_type = 'See review clicked';

  constructor(
    public event_properties: SeeReviewClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SendMessageClicked implements BaseEvent {
  event_type = 'Send message clicked';

  constructor(
    public event_properties: SendMessageClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SendWithAt1FamilyProposition implements BaseEvent {
  event_type = 'send with at1 family proposition';

  constructor(
    public event_properties: SendWithAt1FamilyPropositionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SummaryAiTranscriptViewed implements BaseEvent {
  event_type = 'summary_ai_transcript_viewed';

  constructor(
    public event_properties: SummaryAiTranscriptViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SummarySegmentClicked implements BaseEvent {
  event_type = 'summary_segment_clicked';

  constructor(
    public event_properties: SummarySegmentClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TagDeleted implements BaseEvent {
  event_type = 'Tag deleted';

  constructor(
    public event_properties: TagDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TagSelected implements BaseEvent {
  event_type = 'Tag selected';

  constructor(
    public event_properties: TagSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TestAt1PropositonDisplayed implements BaseEvent {
  event_type = 'test_at1_propositon_displayed';

  constructor(
    public event_properties: TestAt1PropositonDisplayedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ToDoSubTabClicked implements BaseEvent {
  event_type = 'To do sub tab clicked';

  constructor(
    public event_properties: ToDoSubTabClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TranscriptViewed implements BaseEvent {
  event_type = 'transcript_viewed';

  constructor(
    public event_properties: TranscriptViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TravelerCallClicked implements BaseEvent {
  event_type = 'Traveler call clicked';

  constructor(
    public event_properties: TravelerCallClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TravelerCallEnded implements BaseEvent {
  event_type = 'Traveler call ended';

  constructor(
    public event_properties: TravelerCallEndedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TravelerCallMinimized implements BaseEvent {
  event_type = 'Traveler call minimized';

  constructor(
    public event_properties: TravelerCallMinimizedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TravelerCallNoteClicked implements BaseEvent {
  event_type = 'Traveler call note clicked';

  constructor(
    public event_properties: TravelerCallNoteClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TravelerCallStarted implements BaseEvent {
  event_type = 'Traveler call started';

  constructor(
    public event_properties: TravelerCallStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TravelerInformationChanged implements BaseEvent {
  event_type = 'Traveler information changed';

  constructor(
    public event_properties: TravelerInformationChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TravelerInfoLinkClicked implements BaseEvent {
  event_type = 'traveler_info_link_clicked';

  constructor(
    public event_properties: TravelerInfoLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class VideoLinkGenerated implements BaseEvent {
  event_type = 'Video link generated';

  constructor(
    public event_properties: VideoLinkGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewFeedbackClicked implements BaseEvent {
  event_type = 'View feedback clicked';

  constructor(
    public event_properties: ViewFeedbackClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewedLatencyTestReplyClicked implements BaseEvent {
  event_type = 'Viewed latency test reply clicked';

  constructor(
    public event_properties: ViewedLatencyTestReplyClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewedPageFile implements BaseEvent {
  event_type = 'Viewed page file';

  constructor(
    public event_properties: ViewedPageFileProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewedPageInbox implements BaseEvent {
  event_type = 'Viewed page inbox';

  constructor(
    public event_properties: ViewedPageInboxProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewedPagePipeline implements BaseEvent {
  event_type = 'Viewed page pipeline';

  constructor(
    public event_properties: ViewedPagePipelineProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewedPageTemplate implements BaseEvent {
  event_type = 'Viewed page template';

  constructor(
    public event_properties: ViewedPageTemplateProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ViewedPageTodo implements BaseEvent {
  event_type = 'Viewed page todo';

  constructor(
    public event_properties: ViewedPageTodoProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WorkloadStatusClicked implements BaseEvent {
  event_type = 'Workload status clicked';

  constructor(
    public event_properties: WorkloadStatusClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Absence status submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Absence%20status%20submitted)
   *
   * This event tracks the submission of an absence status by a user
   *
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. absence_status_checked)
   * @param options Amplitude event options.
   */
  absenceStatusSubmitted(
    properties: AbsenceStatusSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AbsenceStatusSubmitted(properties), options);
  }

  /**
   * Agent attribution managed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Agent%20attribution%20managed)
   *
   * This event tracks the attribution of agents who are incharge of this request
   *
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  agentAttributionManaged(
    properties: AgentAttributionManagedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AgentAttributionManaged(properties), options);
  }

  /**
   * Agent testimonial clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Agent%20testimonial%20clicked)
   *
   *
   *
   *
   * This event tracks when a user clicks on a cta to leave or read a testimonial on a traveler
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  agentTestimonialClicked(
    properties: AgentTestimonialClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AgentTestimonialClicked(properties), options);
  }

  /**
   * Answer message latency clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Answer%20message%20latency%20clicked)
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  answerMessageLatencyClicked(
    properties: AnswerMessageLatencyClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AnswerMessageLatencyClicked(properties), options);
  }

  /**
   * At1 propositon displayed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/At1%20propositon%20displayed)
   *
   * Indicates when an AT1 message proposal is presented to a user.
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  at1PropositonDisplayed(
    properties: At1PropositonDisplayedProperties,
    options?: EventOptions,
  ) {
    return this.track(new At1PropositonDisplayed(properties), options);
  }

  /**
   * AT1 scheduled
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/AT1%20scheduled)
   *
   * This event tracks when a user schedules an AT1 appointment
   *
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  at1Scheduled(
    properties: At1ScheduledProperties,
    options?: EventOptions,
  ) {
    return this.track(new At1Scheduled(properties), options);
  }

  /**
   * AT1_customize_link_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/AT1_customize_link_clicked)
   *
   * L'agent clique sur "personnaliser" depuis un AT1 auto dans la messagerie
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  at1CustomizeLinkClicked(
    properties: At1CustomizeLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new At1CustomizeLinkClicked(properties), options);
  }

  /**
   * AT2 message action clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/AT2%20message%20action%20clicked)
   *
   * Tracks when a user interacts with a specific action button or link within a message in the At2 messaging interface.
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  at2MessageActionClicked(
    properties: At2MessageActionClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new At2MessageActionClicked(properties), options);
  }

  /**
   * AT2 message check result
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/AT2%20message%20check%20result)
   *
   * Indicates the outcome of verifying the status or validity of an At2 message within the system.
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  at2MessageCheckResult(
    properties: At2MessageCheckResultProperties,
    options?: EventOptions,
  ) {
    return this.track(new At2MessageCheckResult(properties), options);
  }

  /**
   * AT2 message check started
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/AT2%20message%20check%20started)
   *
   * Indicates the initiation of a verification process to check for new or unread messages within the AT2 messaging system.
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  at2MessageCheckStarted(
    properties: At2MessageCheckStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new At2MessageCheckStarted(properties), options);
  }

  /**
   * AT2 message edit suggestion displayed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/AT2%20message%20edit%20suggestion%20displayed)
   *
   * Indicates when a user is shown a suggested edit for a message within the At2 interface, highlighting potential improvements or corrections.
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  at2MessageEditSuggestionDisplayed(
    properties: At2MessageEditSuggestionDisplayedProperties,
    options?: EventOptions,
  ) {
    return this.track(new At2MessageEditSuggestionDisplayed(properties), options);
  }

  /**
   * Attached document explanation toggled
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Attached%20document%20explanation%20toggled)
   *
   *
   *
   *
   * This event tracks when an agent toggles the explanation of what an attached document will look like for the user.
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  attachedDocumentExplanationToggled(
    properties: AttachedDocumentExplanationToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new AttachedDocumentExplanationToggled(properties), options);
  }

  /**
   * Attached document send clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Attached%20document%20send%20clicked)
   *
   *
   *
   *
   * Event: Attached document send clicked
   *
   * Description: This event tracks when a user clicks on the "send" button after attaching a document. It indicates user engagement with the document sending feature and can be used to analyze the usage and effectiveness of this functionality
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  attachedDocumentSendClicked(
    properties: AttachedDocumentSendClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AttachedDocumentSendClicked(properties), options);
  }

  /**
   * Budget notification clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Budget%20notification%20clicked)
   *
   * Event to track when a user clicks on the notification to fill a budget 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  budgetNotificationClicked(
    properties: BudgetNotificationClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BudgetNotificationClicked(properties), options);
  }

  /**
   * Budget updated
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Budget%20updated)
   *
   * Event to track when request budget is updated
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  budgetUpdated(
    properties: BudgetUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new BudgetUpdated(properties), options);
  }

  /**
   * Card dragged or dropped
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Card%20dragged%20or%20dropped)
   *
   * This event tracks when a user drags or drops a card.
   *
   *
   *
   *
   *
   * The property request*\_RM_step dans ce cas renvoie le drop_column*
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. drag_column)
   * @param options Amplitude event options.
   */
  cardDraggedOrDropped(
    properties: CardDraggedOrDroppedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CardDraggedOrDropped(properties), options);
  }

  /**
   * Collect capacity reminder choice clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Collect%20capacity%20reminder%20choice%20clicked)
   *
   * Event to track when a user clicks on a capacity reminder choice. 
   *
   *
   *
   *
   * @param properties The event's properties (e.g. collect_capacity_reminder_choice)
   * @param options Amplitude event options.
   */
  collectCapacityReminderChoiceClicked(
    properties: CollectCapacityReminderChoiceClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectCapacityReminderChoiceClicked(properties), options);
  }

  /**
   * Details initial request clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Details%20initial%20request%20clicked)
   *
   * Click on the details of the initial request 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  detailsInitialRequestClicked(
    properties: DetailsInitialRequestClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DetailsInitialRequestClicked(properties), options);
  }

  /**
   * Discussion add a document clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Discussion%20add%20a%20document%20clicked)
   *
   * This event tracks when a user clicks on the "Add a Document" button within a discussion
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  discussionAddADocumentClicked(
    properties: DiscussionAddADocumentClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscussionAddADocumentClicked(properties), options);
  }

  /**
   * Discussion add a template clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Discussion%20add%20a%20template%20clicked)
   *
   * This event tracks when a user clicks on the option to add a template in the discussion feature
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  discussionAddATemplateClicked(
    properties: DiscussionAddATemplateClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscussionAddATemplateClicked(properties), options);
  }

  /**
   * Discussion template selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Discussion%20template%20selected)
   *
   * This event tracks when a user selects a discussion template from the available options
   *
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  discussionTemplateSelected(
    properties: DiscussionTemplateSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscussionTemplateSelected(properties), options);
  }

  /**
   * Display viewed latency pop-in
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Display%20viewed%20latency%20pop-in)
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  displayViewedLatencyPopIn(
    properties: DisplayViewedLatencyPopInProperties,
    options?: EventOptions,
  ) {
    return this.track(new DisplayViewedLatencyPopIn(properties), options);
  }

  /**
   * Documentation latency clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Documentation%20latency%20clicked)
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  documentationLatencyClicked(
    properties: DocumentationLatencyClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentationLatencyClicked(properties), options);
  }

  /**
   * Due date submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Due%20date%20submitted)
   *
   * This event is triggered when a user submits a due date for a nba
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  dueDateSubmitted(
    properties: DueDateSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DueDateSubmitted(properties), options);
  }

  /**
   * experiment at1 message erased
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/experiment%20at1%20message%20erased)
   *
   * Event of click on an erase button during the experiment in RM.
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  experimentAt1MessageErased(
    properties: ExperimentAt1MessageErasedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExperimentAt1MessageErased(properties), options);
  }

  /**
   * FAQ clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/FAQ%20clicked)
   *
   * Track all accesses to the help center. 
   *
   *
   *
   * @param properties The event's properties (e.g. click_origin)
   * @param options Amplitude event options.
   */
  faqClicked(
    properties: FaqClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FaqClicked(properties), options);
  }

  /**
   * Filter_selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Filter_selected)
   *
   * Event to track when a user selects at least one filter  
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  filterSelected(
    properties: FilterSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FilterSelected(properties), options);
  }

  /**
   * Generate AT1 displayed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Generate%20AT1%20displayed)
   *
   * Event déclenché quand l'event de proposition d'AT1 généré par IA est affiché.
   *
   * Cet event est mis en place depuis le build à tous les segments. Avant (quand c'était en test pour les familles), c'était l'event At1 proposition displayed)
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  generateAt1Displayed(
    properties: GenerateAt1DisplayedProperties,
    options?: EventOptions,
  ) {
    return this.track(new GenerateAt1Displayed(properties), options);
  }

  /**
   * Generate AT1 message clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Generate%20AT1%20message%20clicked)
   *
   * Tracks when a user click to generate an AT1 message.
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  generateAt1MessageClicked(
    properties: GenerateAt1MessageClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new GenerateAt1MessageClicked(properties), options);
  }

  /**
   * Generate recap call RM clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Generate%20recap%20call%20RM%20clicked)
   *
   *
   *
   *
   * Génération d'un message récapitulatif suite à un appel RM avec le voyageur. Cet événement est déclenché lorsque l'agent clique sur le bouton pour créer automatiquement un message
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  generateRecapCallRmClicked(
    properties: GenerateRecapCallRmClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new GenerateRecapCallRmClicked(properties), options);
  }

  /**
   * Give feedback clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Give%20feedback%20clicked)
   *
   * Feedback given clicked by the agent: 
   *
   *
   *
   *
   *
   *
   *
   *
   * @param properties The event's properties (e.g. answer)
   * @param options Amplitude event options.
   */
  giveFeedbackClicked(
    properties: GiveFeedbackClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new GiveFeedbackClicked(properties), options);
  }

  /**
   * Hide feedback clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Hide%20feedback%20clicked)
   *
   *
   * This event tracks when a user clicks on the "Hide feedback" button
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  hideFeedbackClicked(
    properties: HideFeedbackClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HideFeedbackClicked(properties), options);
  }

  /**
   * homepage_viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/homepage_viewed)
   *
   * L’agent accède à la nouvelle homepage
   *
   * @param properties The event's properties (e.g. entry_point)
   * @param options Amplitude event options.
   */
  homepageViewed(
    properties: HomepageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HomepageViewed(properties), options);
  }

  /**
   * Itinerary clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Itinerary%20clicked)
   *
   * Event to track when a user clicks on  itinerary box when he s on a specific request. 
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  itineraryClicked(
    properties: ItineraryClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ItineraryClicked(properties), options);
  }

  /**
   * List attachments clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/List%20attachments%20clicked)
   *
   * This event tracks when a user clicks on attachments list.
   *
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  listAttachmentsClicked(
    properties: ListAttachmentsClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ListAttachmentsClicked(properties), options);
  }

  /**
   * Main information changed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Main%20information%20changed)
   *
   * This event is triggered when the main information of a user is changed. 
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  mainInformationChanged(
    properties: MainInformationChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MainInformationChanged(properties), options);
  }

  /**
   * Mark the file as lost submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Mark%20the%20file%20as%20lost%20submitted)
   *
   * Event indicating that a change to the lost status has been confirmed. 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  markTheFileAsLostSubmitted(
    properties: MarkTheFileAsLostSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MarkTheFileAsLostSubmitted(properties), options);
  }

  /**
   * Meeting room copied
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Meeting%20room%20copied)
   *
   * This event tracks when a meeting room is copied
   *
   *
   *
   *
   *
   * [https://travelsuite.evaneos.com/request-manager/dossier/xxxxxxx/discussion](https://travelsuite.evaneos.com/request-manager/dossier/3114898/discussion)
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  meetingRoomCopied(
    properties: MeetingRoomCopiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MeetingRoomCopied(properties), options);
  }

  /**
   * Meltingspot lightbulb clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Meltingspot%20lightbulb%20clicked)
   *
   *
   *
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  meltingspotLightbulbClicked(
    properties: MeltingspotLightbulbClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MeltingspotLightbulbClicked(properties), options);
  }

  /**
   * Memo closed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Memo%20closed)
   *
   * This event tracks when an agent closes the memo modal (click on the cross).
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  memoClosed(
    properties: MemoClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MemoClosed(properties), options);
  }

  /**
   * Memo expanded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Memo%20expanded)
   *
   * This event tracks when an agent expands the memo. 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  memoExpanded(
    properties: MemoExpandedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MemoExpanded(properties), options);
  }

  /**
   * Memo saved
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Memo%20saved)
   *
   * Event indicating that a user has saved a memo 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  memoSaved(
    properties: MemoSavedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MemoSaved(properties), options);
  }

  /**
   * message_edit_cancel_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/message_edit_cancel_clicked)
   *
   *
   *
   *
   * Annulation de l’édition
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  messageEditCancelClicked(
    properties: MessageEditCancelClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MessageEditCancelClicked(properties), options);
  }

  /**
   * message_edit_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/message_edit_clicked)
   *
   *
   *
   *
   * click sur le bouton modifier un message = entrée en mode édition
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  messageEditClicked(
    properties: MessageEditClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MessageEditClicked(properties), options);
  }

  /**
   * message_edit_submit_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/message_edit_submit_clicked)
   *
   *
   *
   *
   * Validation de l’édition
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  messageEditSubmitClicked(
    properties: MessageEditSubmitClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MessageEditSubmitClicked(properties), options);
  }

  /**
   * NBA note submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/NBA%20note%20submitted)
   *
   * Event indicating the creation of a note related to NBA  
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  nbaNoteSubmitted(
    properties: NbaNoteSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NbaNoteSubmitted(properties), options);
  }

  /**
   * New tag added
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/New%20tag%20added)
   *
   * Event indicating that a tag has been created and added on a specific file 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  newTagAdded(
    properties: NewTagAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewTagAdded(properties), options);
  }

  /**
   * New template submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/New%20template%20submitted)
   *
   * This event is triggered when a user submits a new template
   *
   *
   *
   *
   *
   * <https://travelsuite.evaneos.com/request-manager/templates/new>
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  newTemplateSubmitted(
    properties: NewTemplateSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewTemplateSubmitted(properties), options);
  }

  /**
   * new_file_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/new_file_clicked)
   *
   * L’agent clique sur une nouvelle demande dans le bloc "Nouvelles demandes”
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  newFileClicked(
    properties: NewFileClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewFileClicked(properties), options);
  }

  /**
   * new_message_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/new_message_clicked)
   *
   * L’agent clique sur un message dans le bloc "Nouveaux messages”
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  newMessageClicked(
    properties: NewMessageClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewMessageClicked(properties), options);
  }

  /**
   * new_notification_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/new_notification_clicked)
   *
   *
   * L’agent clique sur une nouvelle notification dans le bloc "Important notifications”
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  newNotificationClicked(
    properties: NewNotificationClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NewNotificationClicked(properties), options);
  }

  /**
   * Next best action submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Next%20best%20action%20submitted)
   *
   * This event is triggered when a user submits their next best action.
   *
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  nextBestActionSubmitted(
    properties: NextBestActionSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new NextBestActionSubmitted(properties), options);
  }

  /**
   * Option way clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Option%20way%20clicked)
   *
   * Clic sur "Accéder à Option way" depuis la vue dossier. 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  optionWayClicked(
    properties: OptionWayClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OptionWayClicked(properties), options);
  }

  /**
   * overdue_message_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/overdue_message_clicked)
   *
   * L’agent clique sur voir les messages en attente (sans réponse depuis de plus de 48h)
   *
   *
   *
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  overdueMessageClicked(
    properties: OverdueMessageClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OverdueMessageClicked(properties), options);
  }

  /**
   * Panel contract viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Panel%20contract%20viewed)
   *
   * Clic sur le "paneau" Contract depuis la vue dossier. 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  panelContractViewed(
    properties: PanelContractViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PanelContractViewed(properties), options);
  }

  /**
   * PhoneNumber_Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/PhoneNumber_Viewed)
   *
   * L’agent clic pour afficher le numéro de téléphone du voyageur
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  phoneNumberViewed(
    properties: PhoneNumberViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PhoneNumberViewed(properties), options);
  }

  /**
   * Postpone request clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Postpone%20request%20clicked)
   *
   * Clic sur "Reporter la demande" depuis la vue dossier. 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  postponeRequestClicked(
    properties: PostponeRequestClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PostponeRequestClicked(properties), options);
  }

  /**
   * quick_action_used
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/quick_action_used)
   *
   * L’agent utilise une action rapide (réponse non nécessaire, répondu hors RM, etc.)
   *
   * @param properties The event's properties (e.g. action_type)
   * @param options Amplitude event options.
   */
  quickActionUsed(
    properties: QuickActionUsedProperties,
    options?: EventOptions,
  ) {
    return this.track(new QuickActionUsed(properties), options);
  }

  /**
   * raw_transcript_opened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/raw_transcript_opened)
   *
   *
   * The agent opens the raw transcript
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  rawTranscriptOpened(
    properties: RawTranscriptOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RawTranscriptOpened(properties), options);
  }

  /**
   * recording_downloaded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/recording_downloaded)
   *
   *
   * The agent downloads a recording
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  recordingDownloaded(
    properties: RecordingDownloadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RecordingDownloaded(properties), options);
  }

  /**
   * recording_listened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/recording_listened)
   *
   *
   * The agent listens to a recording
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  recordingListened(
    properties: RecordingListenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RecordingListened(properties), options);
  }

  /**
   * recording_paused
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/recording_paused)
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  recordingPaused(
    properties: RecordingPausedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RecordingPaused(properties), options);
  }

  /**
   * recording_started
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/recording_started)
   *
   * The agent click on 'Record' or on 'Resume'. The button 'Resume' appears after an agent has cliked on 'Pause' to stop the record. 'Resume' is used to restart the recording. 
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  recordingStarted(
    properties: RecordingStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RecordingStarted(properties), options);
  }

  /**
   * Regenerate recording AI content clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Regenerate%20recording%20AI%20content%20clicked)
   *
   * When a user uses the features to regenerate either the raw transcript or the summary of a recorded call. This event is tracked when a user clicks on the "Follow up" confirmation button (red) of the popin that appears just after he clicked on the "Follow up on summary generation" or "Regenerate transcript" buttons (blue). 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  regenerateRecordingAiContentClicked(
    properties: RegenerateRecordingAiContentClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RegenerateRecordingAiContentClicked(properties), options);
  }

  /**
   * Reopen file
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Reopen%20file)
   *
   *
   *
   *  Event indicating that a file in deferred trip has been reopen.
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  reopenFile(
    properties: ReopenFileProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReopenFile(properties), options);
  }

  /**
   * Reveal message latency clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Reveal%20message%20latency%20clicked)
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  revealMessageLatencyClicked(
    properties: RevealMessageLatencyClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RevealMessageLatencyClicked(properties), options);
  }

  /**
   * RM assistant  offer a call submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20%20offer%20a%20call%20submitted)
   *
   * @Event indicating that the user declared he offered a call with the traveler 
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  rmAssistantOfferACallSubmitted(
    properties: RmAssistantOfferACallSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantOfferACallSubmitted(properties), options);
  }

  /**
   * RM assistant access to files clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20access%20to%20files%20clicked)
   *
   * Event to track when the user clicks on files proposed by rm assistant 
   *
   *
   *
   * @param properties The event's properties (e.g. block_assistant_task)
   * @param options Amplitude event options.
   */
  rmAssistantAccessToFilesClicked(
    properties: RmAssistantAccessToFilesClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantAccessToFilesClicked(properties), options);
  }

  /**
   * RM assistant arrow clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20arrow%20clicked)
   *
   * Event to track when a user clicks on the assistant arrow to go the next or previous file 
   *
   *
   *
   * @param properties The event's properties (e.g. assistant_arrow_direction)
   * @param options Amplitude event options.
   */
  rmAssistantArrowClicked(
    properties: RmAssistantArrowClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantArrowClicked(properties), options);
  }

  /**
   * RM assistant call done submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20call%20done%20submitted)
   *
   * Event indicating that a call has been completed and declared as done. 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  rmAssistantCallDoneSubmitted(
    properties: RmAssistantCallDoneSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantCallDoneSubmitted(properties), options);
  }

  /**
   * RM assistant clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20clicked)
   *
   * Event indicating that a user clicked on the RM assistant feature. 
   *
   *
   *
   * @param properties The event's properties (e.g. assistant_number_files)
   * @param options Amplitude event options.
   */
  rmAssistantClicked(
    properties: RmAssistantClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantClicked(properties), options);
  }

  /**
   * RM assistant closed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20closed)
   *
   * Event indicating that a user clicked to close the Assistant feature. 
   *
   *
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  rmAssistantClosed(
    properties: RmAssistantClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantClosed(properties), options);
  }

  /**
   * RM assistant file displayed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20file%20displayed)
   *
   * Event to track when a user views a file with  RM assistant feature 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  rmAssistantFileDisplayed(
    properties: RmAssistantFileDisplayedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantFileDisplayed(properties), options);
  }

  /**
   * RM assistant message sent
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20message%20sent)
   *
   * Event indicating that a message has been sent if the file has been recommended by rm assistant. 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  rmAssistantMessageSent(
    properties: RmAssistantMessageSentProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantMessageSent(properties), options);
  }

  /**
   * RM assistant modal displayed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20modal%20displayed)
   *
   * Event indicating when the modal RM assistant is displayed . 
   *
   *
   *
   * @param properties The event's properties (e.g. assistant_number_files)
   * @param options Amplitude event options.
   */
  rmAssistantModalDisplayed(
    properties: RmAssistantModalDisplayedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantModalDisplayed(properties), options);
  }

  /**
   * RM assistant next file clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20next%20file%20clicked)
   *
   * Event indicating that the user clicked on the next file button in the Assistant feature. 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  rmAssistantNextFileClicked(
    properties: RmAssistantNextFileClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantNextFileClicked(properties), options);
  }

  /**
   * RM assistant proposal sent submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20proposal%20sent%20submitted)
   *
   * Event indicating that a user clicked to declare a proposal has been send 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  rmAssistantProposalSentSubmitted(
    properties: RmAssistantProposalSentSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantProposalSentSubmitted(properties), options);
  }

  /**
   * RM assistant task not necessary clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20assistant%20task%20not%20necessary%20clicked)
   *
   * The user indicate the task submitted is not relevant 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  rmAssistantTaskNotNecessaryClicked(
    properties: RmAssistantTaskNotNecessaryClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmAssistantTaskNotNecessaryClicked(properties), options);
  }

  /**
   * RM discussion response no required submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20discussion%20response%20no%20required%20submitted)
   *
   * Event indicating that a response is not required from the agent to the traveler 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  rmDiscussionResponseNoRequiredSubmitted(
    properties: RmDiscussionResponseNoRequiredSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmDiscussionResponseNoRequiredSubmitted(properties), options);
  }

  /**
   * RM Filter clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/RM%20Filter%20clicked)
   *
   * L'agent clique sur "Filters" dans RM.
   *
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  rmFilterClicked(
    properties: RmFilterClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RmFilterClicked(properties), options);
  }

  /**
   * Sale potential selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Sale%20potential%20selected)
   *
   * current sale potential qualification on the file
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  salePotentialSelected(
    properties: SalePotentialSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SalePotentialSelected(properties), options);
  }

  /**
   * Sale step changed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Sale%20step%20changed)
   *
   * Changement de la valeur de l'étape de vente. 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  saleStepChanged(
    properties: SaleStepChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SaleStepChanged(properties), options);
  }

  /**
   * Save agent testimonial clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Save%20agent%20testimonial%20clicked)
   *
   *
   *
   *
   * This event tracks when a user clicks on the "Save" button for an agent testimonial
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  saveAgentTestimonialClicked(
    properties: SaveAgentTestimonialClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SaveAgentTestimonialClicked(properties), options);
  }

  /**
   * ScheduledMessage_Cancelled
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/ScheduledMessage_Cancelled)
   *
   * L’agent annule la création avant validation
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  scheduledMessageCancelled(
    properties: ScheduledMessageCancelledProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScheduledMessageCancelled(properties), options);
  }

  /**
   * ScheduledMessage_Confirmed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/ScheduledMessage_Confirmed)
   *
   * L’agent confirme la programmation du message
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  scheduledMessageConfirmed(
    properties: ScheduledMessageConfirmedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScheduledMessageConfirmed(properties), options);
  }

  /**
   * ScheduledMessage_Deleted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/ScheduledMessage_Deleted)
   *
   * Suppression d’un message programmé
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  scheduledMessageDeleted(
    properties: ScheduledMessageDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScheduledMessageDeleted(properties), options);
  }

  /**
   * ScheduledMessage_Edited
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/ScheduledMessage_Edited)
   *
   *
   * Edition d’un message programmé (clic sur le bouton edit)
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  scheduledMessageEdited(
    properties: ScheduledMessageEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScheduledMessageEdited(properties), options);
  }

  /**
   * ScheduledMessage_OpenModal
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/ScheduledMessage_OpenModal)
   *
   * L’agent clique sur “Programmer un message”
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  scheduledMessageOpenModal(
    properties: ScheduledMessageOpenModalProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScheduledMessageOpenModal(properties), options);
  }

  /**
   * See review clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/See%20review%20clicked)
   *
   *
   *
   *
   * This event tracks when a user clicks on the "See review" button, indicating their interest in reading reviews for a particular item or service.
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  seeReviewClicked(
    properties: SeeReviewClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SeeReviewClicked(properties), options);
  }

  /**
   * Send message clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Send%20message%20clicked)
   *
   * Event to track when a user send a message in the discussion. 
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  sendMessageClicked(
    properties: SendMessageClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SendMessageClicked(properties), options);
  }

  /**
   * send with at1 family proposition
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/send%20with%20at1%20family%20proposition)
   *
   * Event to track when a user sends a family proposition with AT1.
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  sendWithAt1FamilyProposition(
    properties: SendWithAt1FamilyPropositionProperties,
    options?: EventOptions,
  ) {
    return this.track(new SendWithAt1FamilyProposition(properties), options);
  }

  /**
   * summary_ai_transcript_viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/summary_ai_transcript_viewed)
   *
   *
   * The agent opens or reopens the AI-generated call summary
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  summaryAiTranscriptViewed(
    properties: SummaryAiTranscriptViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SummaryAiTranscriptViewed(properties), options);
  }

  /**
   * summary_segment_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/summary_segment_clicked)
   *
   *
   * The agent clicks on a word or segment in the summary to listen to the corresponding part of the call
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  summarySegmentClicked(
    properties: SummarySegmentClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SummarySegmentClicked(properties), options);
  }

  /**
   * Tag deleted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Tag%20deleted)
   *
   * Event indicating that a tag has been deleted
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  tagDeleted(
    properties: TagDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TagDeleted(properties), options);
  }

  /**
   * Tag selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Tag%20selected)
   *
   * Event indicating that a tag already created it has been selected by a user and added on the file 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  tagSelected(
    properties: TagSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TagSelected(properties), options);
  }

  /**
   * test_at1_propositon_displayed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/test_at1_propositon_displayed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  testAt1PropositonDisplayed(
    properties: TestAt1PropositonDisplayedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TestAt1PropositonDisplayed(properties), options);
  }

  /**
   * To do sub tab clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/To%20do%20sub%20tab%20clicked)
   *
   * Event to track when a user clicks on sub tab i. the TO DO section 
   *
   *
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  toDoSubTabClicked(
    properties: ToDoSubTabClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ToDoSubTabClicked(properties), options);
  }

  /**
   * transcript_viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/transcript_viewed)
   *
   *
   * The agent opens the arrow "Transcript" tab
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  transcriptViewed(
    properties: TranscriptViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TranscriptViewed(properties), options);
  }

  /**
   * Traveler call clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Traveler%20call%20clicked)
   *
   * This event tracks when a requester clicks on the "call" button to initiate a phone call.
   *
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  travelerCallClicked(
    properties: TravelerCallClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TravelerCallClicked(properties), options);
  }

  /**
   * Traveler call ended
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Traveler%20call%20ended)
   *
   * This event tracks when an agent ended a phone call with a traveler
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  travelerCallEnded(
    properties: TravelerCallEndedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TravelerCallEnded(properties), options);
  }

  /**
   * Traveler call minimized
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Traveler%20call%20minimized)
   *
   * This event tracks when an agent minimize the modale phone call
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  travelerCallMinimized(
    properties: TravelerCallMinimizedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TravelerCallMinimized(properties), options);
  }

  /**
   * Traveler call note clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Traveler%20call%20note%20clicked)
   *
   * This event tracks when an agent clicks on "take notes" button on the phone call modal 
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  travelerCallNoteClicked(
    properties: TravelerCallNoteClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TravelerCallNoteClicked(properties), options);
  }

  /**
   * Traveler call started
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Traveler%20call%20started)
   *
   * This event tracks when an agent click to started the call with the traveler
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  travelerCallStarted(
    properties: TravelerCallStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TravelerCallStarted(properties), options);
  }

  /**
   * Traveler information changed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Traveler%20information%20changed)
   *
   * This event tracks when a traveler's information has been changed in the system.
   *
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  travelerInformationChanged(
    properties: TravelerInformationChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TravelerInformationChanged(properties), options);
  }

  /**
   * traveler_info_link_clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/traveler_info_link_clicked)
   *
   * Triggered when a user clicks the “See info” link to view newly collected information from a traveler.
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  travelerInfoLinkClicked(
    properties: TravelerInfoLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TravelerInfoLinkClicked(properties), options);
  }

  /**
   * Video link generated
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Video%20link%20generated)
   *
   * This event tracks when a video link is generated by an agent
   *
   * url: [https://travelsuite.evaneos.com/request-manager/dossier/xxxxxxx/discussion](https://travelsuite.evaneos.com/request-manager/dossier/3114898/discussion)
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  videoLinkGenerated(
    properties: VideoLinkGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new VideoLinkGenerated(properties), options);
  }

  /**
   * View feedback clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/View%20feedback%20clicked)
   *
   *
   * This event tracks when a user clicks on the "View feedback" button
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  viewFeedbackClicked(
    properties: ViewFeedbackClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewFeedbackClicked(properties), options);
  }

  /**
   * Viewed latency test reply clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Viewed%20latency%20test%20reply%20clicked)
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  viewedLatencyTestReplyClicked(
    properties: ViewedLatencyTestReplyClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewedLatencyTestReplyClicked(properties), options);
  }

  /**
   * Viewed page file
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Viewed%20page%20file)
   *
   *
   * This event tracks when a user views a specific page related to a travel request
   *
   * @param properties The event's properties (e.g. agency_id)
   * @param options Amplitude event options.
   */
  viewedPageFile(
    properties: ViewedPageFileProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewedPageFile(properties), options);
  }

  /**
   * Viewed page inbox
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Viewed%20page%20inbox)
   *
   * This event is triggered when a user views the inbox page.
   *
   * url: https://travelsuite.evaneos.com/request-manager/inbox
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  viewedPageInbox(
    properties: ViewedPageInboxProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewedPageInbox(properties), options);
  }

  /**
   * Viewed page pipeline
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Viewed%20page%20pipeline)
   *
   * This event tracks when a pipeline page is viewed. There is a propety on tabs: sales | Operation | Archive
   *
   * url: https://travelsuite.evaneos.com/request-manager/process
   *
   *
   *
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  viewedPagePipeline(
    properties: ViewedPagePipelineProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewedPagePipeline(properties), options);
  }

  /**
   * Viewed page template
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Viewed%20page%20template)
   *
   * This event tracks when a user views a template page
   *
   *
   *
   *
   *
   * <https://travelsuite.evaneos.com/request-manager/templates/list>
   *
   * Owner: agnes.dury@evaneos.com
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  viewedPageTemplate(
    properties: ViewedPageTemplateProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewedPageTemplate(properties), options);
  }

  /**
   * Viewed page todo
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Viewed%20page%20todo)
   *
   *
   *
   *
   *
   * To Do List page view
   *
   * @param properties The event's properties (e.g. ets_source)
   * @param options Amplitude event options.
   */
  viewedPageTodo(
    properties: ViewedPageTodoProperties,
    options?: EventOptions,
  ) {
    return this.track(new ViewedPageTodo(properties), options);
  }

  /**
   * Workload status clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/evaneos/Evaneos%20Travel%20Suite/events/main/latest/Workload%20status%20clicked)
   *
   * agent updated a new workload status
   *
   *
   *
   *
   * @param properties The event's properties (e.g. agent_workload_level)
   * @param options Amplitude event options.
   */
  workloadStatusClicked(
    properties: WorkloadStatusClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WorkloadStatusClicked(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
